export const environment = {
  production: false,
  name:"(DEV)",
  url: 'https://api.carvia-test.org',
  lfyAuth: 'https://api.carvia-test.org/listingfy-auth',
  // baseUrl: 'https://dapi.carvia.tech/lfy-service',
  basicAuth: 'YWNtZTphY21lc2VjcmV0'
};
